import { Banner, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { urlBuilder } from '../../Shared/urlBuilder';

export const InvalidPIIBanner: React.FC = () => {
  return (
    <Banner variant="warning">
      <Banner.Content>
        <Text as="p">
          One or more fields above contain invalid characters (e.g., ;, $, %, _, or extra spaces). Update your
          information in <SambaAutoLink to={urlBuilder.appProfile.absolute()}>Settings</SambaAutoLink> to continue.
        </Text>
      </Banner.Content>
    </Banner>
  );
};
